export default "__VITE_ASSET__DZhojevG__"